import {AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2, signal} from '@angular/core';

@Directive({
    selector: '[pasWidthResizable]',
    standalone: true
})
export class WidthResizableDirective implements AfterViewInit, OnDestroy {
    @Input() pasWidthResizable: boolean = true;
    private isStartResize = signal<boolean>(false);
    leftRule: HTMLElement|null = null;
    rightRule: HTMLElement|null = null;

    constructor(private element: ElementRef, private renderer: Renderer2) {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.pasWidthResizable) {
                this.renderer.setStyle(
                    this.element.nativeElement,
                    'position',
                    'relative'
                );
                this.leftRule = this.renderer.createElement('div');
                this.leftRule!.classList.add('resize-rule', 'resize-rule__left');
                this.rightRule = this.renderer.createElement('div');
                this.rightRule!.classList.add('resize-rule', 'resize-rule__right');
                this.leftRule!.addEventListener('mousedown', (event: MouseEvent) => this.startResize(event, this.element.nativeElement, -1, false));
                this.rightRule!.addEventListener('mousedown', (event: MouseEvent) => this.startResize(event, this.element.nativeElement, 1, false));
                this.leftRule!.addEventListener('touchstart', (event: TouchEvent) => this.startResize(event, this.element.nativeElement, -1, true));
                this.rightRule!.addEventListener('touchstart', (event: TouchEvent) => this.startResize(event, this.element.nativeElement, 1, true));
                this.element.nativeElement.prepend(this.leftRule);
                this.element.nativeElement.append(this.rightRule);
            }
        })
    }

    startResize(event: MouseEvent | TouchEvent, headerContent: HTMLElement, direction: 1 | -1 = 1, isTouch = false): void {
        event.preventDefault();
        event.stopPropagation();
        this.isStartResize.set(true);
        const headerCell = headerContent.closest('th');
        const startX = isTouch
            ? (event as TouchEvent).touches[0].clientX
            : (event as MouseEvent).clientX;
        const startWidth = headerCell!.getBoundingClientRect().width;

        const onMouseMove = (moveEvent: MouseEvent | TouchEvent): void => {
            const clientX = isTouch
                ? (moveEvent as TouchEvent).touches[0].clientX
                : (moveEvent as MouseEvent).clientX;
            const diff = clientX - startX;
            const newWidth = Math.max(50, startWidth + diff * direction);
            this.renderer.setStyle(headerCell, 'width', `${newWidth}px`);
        };

        const onMouseUp = (): void => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('touchmove', onMouseMove);
            document.removeEventListener('touchend', onMouseUp);
            setTimeout(() => {
                this.isStartResize.set(false);
            }, 200);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('touchmove', onMouseMove);
        document.addEventListener('touchend', onMouseUp);
    }

    ngOnDestroy(): void {
        if(this.leftRule) this.leftRule.remove();
        if(this.rightRule) this.rightRule.remove();
    }


}
